export enum SupportGaCategory {
  Pages = 'support-pages',
}
